import useSWR from "swr";
import type { AssistantApi } from "~/components/assistant/api/AssistantApi";

const SKILL_TEMPLATES_KEY = "skill-templates" as const;

export function useSkillTemplates(api: AssistantApi, search?: string, shouldFetch = true) {
  const {
    data: templates = [],
    isLoading,
    error,
  } = useSWR(shouldFetch ? [SKILL_TEMPLATES_KEY, search] : null, () =>
    api.listSkillTemplates(search)
  );

  return { templates, isLoading, error };
}
